<template>
	<div class="box scroll-y" style="height: 500px">
		<div class="padding h-100">
			<span class="refresh text-muted">
				<a @click="loadData" class="no-select btn-subtle" v-tippy title="Refresh">
					<i class="fa fa-sync text-sm" :class="{ 'fa-spin': busy }"></i>
				</a>
			</span>
			<table style="width: 100%">
				<tr>
					<th class="text-muted">Assessment</th>
					<th
						class="text-muted text-center"
						style="width: 200px"
						v-tippy
						title="Number of complete responses"
					>
						Number of Students
					</th>
					<th
						class="text-muted text-center"
						style="width: 200px"
						v-tippy
						title="Average total response score"
					>
						School Avg. Score
					</th>
					<th
						class="text-muted text-center"
						style="width: 200px"
						v-tippy
						title="Average total response score"
					>
						District Avg. Score
					</th>
				</tr>
				<tr v-for="(stat, i) in stats" :key="stat.assessment_id" class="b-t">
					<td class="pl-0 align-top" style="overflow: hidden; white-space: nowrap">
						<div style="padding-top: 14px; margin-bottom: 24px">
							{{ stat.assessment_name }}&nbsp;
							<a
								v-if="!traitTableShouldBeShown(stat.assessment_id)"
								@click="toggleTraitTable(stat.assessment_id)"
								class=""
								v-tippy
								title="Show Traits"
							>
								<i class="fa fa-plus text-sm"></i>
							</a>
							<a
								v-if="traitTableShouldBeShown(stat.assessment_id)"
								@click="toggleTraitTable(stat.assessment_id)"
								class=""
								v-tippy
								title="Hide Traits"
							>
								<i class="fa fa-minus text-sm"></i>
							</a>
						</div>
						<div v-if="traitTableShouldBeShown(stat.assessment_id)">
							<div
								class="border-top"
								style="height: 34px"
								v-for="traitScore in getAssessmentTraits(stat.assessment_id)"
							>
								<div style="padding-top: 3px">
									&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
										getTraitName(stat.assessment_id, traitScore.trait_id)
									}}
								</div>
							</div>
						</div>
					</td>
					<td class="align-top">
						<div class="text-center score-num" style="margin-top: 2px">
							{{ stat.complete }}
						</div>
						<div v-if="traitTableShouldBeShown(stat.assessment_id)">
							<br />
							<div
								class="border-top"
								style="margin-left: -20px; margin-top: -2px; height: 36px"
								v-for="traitScore in getAssessmentTraits(stat.assessment_id)"
							>
								<div class="trait-score-num">&nbsp;</div>
							</div>
						</div>
					</td>
					<td class="text-center align-top">
						<div v-tippy :title="scoreTooltip(stat)">
							<div class="score-num">{{ fs.fixed12d(stat.avg_score) }}</div>
							<div class="text-muted" style="margin-top: -0.5rem">{{ fs.fixed1d(stat.percent) }}%</div>
						</div>

						<div v-if="traitTableShouldBeShown(stat.assessment_id)">
							<div style="margin-left: -20px; padding-top: 8px">
								<div
									class="border-top"
									style="height: 34px; padding-left: 20px"
									v-for="traitScore in getAssessmentTraits(stat.assessment_id)"
								>
									<span class="trait-score-num">
										{{ fs.fixed12d(traitScore.avg_score) }}
									</span>
									<span
										style="margin-top: -0.5rem"
										:class="{
											'green-text':
												getDistrictDifference(
													Math.round(traitScore.avg_score * 10) / 10,
													getDistrictTraitScore(stat.assessment_id, traitScore.trait_id)
												) > 0,
											'red-text':
												getDistrictDifference(
													Math.round(traitScore.avg_score * 10) / 10,
													getDistrictTraitScore(stat.assessment_id, traitScore.trait_id)
												) < 0,
										}"
										v-tippy
										title="Compared to District"
									>
										(
										<span
											v-if="
												getDistrictDifference(
													Math.round(traitScore.avg_score * 10) / 10,
													getDistrictTraitScore(stat.assessment_id, traitScore.trait_id)
												) > 0
											"
										>
											+
										</span>
										<span
											:class="{
												'green-text':
													getDistrictDifference(
														Math.round(traitScore.avg_score * 10) / 10,
														getDistrictTraitScore(stat.assessment_id, traitScore.trait_id)
													) > 0,
												'red-text':
													getDistrictDifference(
														Math.round(traitScore.avg_score * 10) / 10,
														getDistrictTraitScore(stat.assessment_id, traitScore.trait_id)
													) < 0,
											}"
										>
											{{
												getDistrictDifference(
													Math.round(traitScore.avg_score * 10) / 10,
													getDistrictTraitScore(stat.assessment_id, traitScore.trait_id)
												)
											}}
											)
										</span>
									</span>
								</div>
							</div>
						</div>
					</td>
					<td class="text-center align-top">
						<div v-tippy :title="scoreTooltip(getDistrictStat(stat.assessment_id))">
							<div class="score-num">
								{{ fs.fixed12d(getDistrictStat(stat.assessment_id).avg_score) }}
							</div>
							<div class="text-muted" style="margin-top: -0.5rem">
								{{ fs.fixed1d(getDistrictStat(stat.assessment_id).percent) }}%
							</div>
						</div>
						<div v-if="traitTableShouldBeShown(stat.assessment_id)">
							<div style="margin-left: -20px; padding-top: 8px">
								<div
									class="border-top"
									style="height: 34px; padding-left: 20px"
									v-for="traitScore in getAssessmentTraits(stat.assessment_id)"
								>
									<div class="trait-score-num">
										{{ getDistrictTraitScore(stat.assessment_id, traitScore.trait_id) }}
									</div>
								</div>
							</div>
						</div>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<style scoped>
a {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a:hover {
	opacity: 1;
}
table a {
	cursor: default;
}
a.clickable {
	cursor: pointer;
}
a.clickable > h1 {
	border-radius: 0.5rem;
	transition: background-color 0.25s;
	padding-bottom: 2px;
}
a.clickable > h1:hover {
	background-color: rgb(0, 0, 0, 0.05);
}
table {
	width: 100%;
}
td {
	padding: 0.25rem 0.5rem;
	text-overflow: ellipsis;
}
th {
	font-size: 1rem;
	font-weight: 500;
}
.refresh {
	position: absolute;
	top: 1.25rem;
	right: 1.25rem;
}
::-webkit-scrollbar {
	width: 7px;
}
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.2);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
.score-num {
	font-size: 1.5rem;
}
.trait-score-num {
	font-size: 1.3rem;
}
.fa-plus {
	cursor: pointer;
}
.fa-minus {
	cursor: pointer;
}
.green-text {
	color: green !important;
}
.red-text {
	color: red;
}
</style>

<script>
import ReportingService from "@/services/ReportingService";
import store from "@/services/Store";
import fs from "@/services/FormatService";
import chartjs from "chart.js";
require("@/directives/chartjs");
import moment from "moment";

export default {
	name: "SchoolDashScores",

	props: ["districtID", "schoolID"],

	data() {
		return {
			fs: fs,
			busy: false,
			stats: [],
			districtStats: [],
			schoolTraitScores: null,
			districtTraitScores: null,
			showTraitTableArr: [],
		};
	},
	created() {
		this.loadData();
	},
	watch: {
		schoolID() {
			this.loadData();
		},
		stats() {
			_.each(this.stats, (stat) => {
				this.showTraitTableArr.push({ assessment_id: stat.assessment_id, show: false });
			});
		},
	},
	methods: {
		loadData() {
			if (this.busy) {
				return;
			}

			this.busy = true;
			ReportingService.getSchoolScores(this.districtID, this.schoolID)
				.then((resp) => {
					this.stats = resp.data.objWithCalculatedAverage;
					_.each(this.stats, (stat) => {
						this.calcScoreRange(stat);
					});
					this.schoolTraitScores = resp.data.objWithTraitScores;
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					this.busy = false;
				});

			this.busy = true;
			ReportingService.getDistrictScores(this.districtID)
				.then((resp) => {
					this.districtStats = resp.data.objWithCalculatedAverage;
					_.each(this.districtStats, (stat) => {
						this.calcScoreRange(stat);
					});
					this.districtTraitScores = resp.data.objWithTraitScores;
				})
				.catch((err) => {
					console.log(err);
				})
				.finally(() => {
					this.busy = false;
				});
		},

		calcScoreRange(stat) {
			let min = 0;
			let max = 0;
			let noWeight = true;
			console.log("TRIT FROM calcScoreRange ", stat);
			_.each(stat.rubric.traits, (trait) => {
				if (trait.weight != 0) {
					noWeight = false;
				}
			});

			_.each(stat.rubric.traits, (trait) => {
				if (!trait.separator) {
					if (noWeight) {
						min += trait.min;
						max += trait.max;
					} else {
						min += trait.min * trait.weight;
						max += trait.max * trait.weight;
					}
				}
			});

			stat.min = min;
			stat.max = max;
			stat.percent = ((stat.avg_score - stat.min) * 100) / (stat.max - stat.min);
		},

		scoreTooltip(stat) {
			return `
			<table>
				<tr><td class="pr-2 text-muted">Min score:</td><td>${stat.min}</td></tr>
				<tr><td class="pr-2 text-muted">Max score:</td><td>${stat.max}</td></tr>
				<tr><td class="pr-2 text-muted">Avg score:</td><td>${fs.fixed12d(stat.avg_score)}</td></tr>
				<tr><td class="pr-2 text-muted">Avg score %:</td><td>${fs.fixed1d(stat.percent)}</td></tr>
			</table>`;
		},

		toggleTraitTable(assessmentID) {
			console.log("thistraitTableShouldBeShown", !this.traitTableShouldBeShown(assessmentID));
			let obj = this.showTraitTableArr.find((elem) => elem.assessment_id === assessmentID);
			obj.show = !obj.show;
		},

		traitTableShouldBeShown(assessmentID) {
			return this.showTraitTableArr.find((elem) => elem.assessment_id === assessmentID).show;
		},

		getAssessmentTraits(assessmentID) {
			// console.log("schoolTraitScores",this.schoolTraitScores.find(elem => elem.assessment_id === assessmentID).trait_scores)
			return this.schoolTraitScores.find((elem) => elem.assessment_id === assessmentID).trait_scores;
		},

		getTraitName(assessmentID, traitID) {
			const assessment = this.schoolTraitScores.find((elem) => elem.assessment_id === assessmentID);
			// console.log(" assessment ID ",assessmentID)
			// var i;
			// for (i = 0; i < assessment.rubric.traits.length; i++) {
			// 	console.log("ID IS ",assessment.rubric.traits[i].id,"||",traitID,"||",assessment.rubric.traits[i].id==traitID)
			// }
			try {
				let name = assessment.rubric.traits.find((elem) => elem.id == traitID).name;
				if (name.length > 80) {
					name = name.substring(0, 77);
					name = name.concat("...");
				}
				return name;
			} catch (err) {
				return "NO NAME FOR TRAIT";
			}
		},

		getDistrictTraitScore(assessmentID, traitID) {
			// console.log(" getDistrictTraitScore assessment",this.districtTraitScores)

			const assessment = this.districtTraitScores.find((elem) => elem.assessment_id === assessmentID);
			let avg_score = assessment.trait_scores.find((elem) => elem.trait_id === traitID).avg_score;
			avg_score = Math.round(avg_score * 100) / 100;
			return avg_score;
		},

		getDistrictDifference(schoolScore, districtScore) {
			return Math.round((schoolScore - districtScore) * 100) / 100;
		},

		getDistrictStat(asmtID) {
			return _.find(this.districtStats, { assessment_id: asmtID });
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/school_dashboard/SchoolDashScores.vue